import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import LabSubscriberForm from './LabSubscriberForm';
import { labSubscriberService } from 'services/api';
import { ILabSubscriber } from 'interfaces';

const initLabSubscriber: ILabSubscriber = {
  company_name: '',
  endpoint: '',
  is_active: true,
  suppliers: [],
  suppliers_display: []
};

export const CreateLabSubscriber = () => {
  const translationPrefix = 'pages.lab-subscriber-settings.new';
  const { t } = useTranslation();
  const navigate = useNavigate();

  const createLabSubscriber = async (values: {
    company_name: string;
    is_active: boolean;
    endpoint: string;
    suppliers: number[];
  }) => {
    const res = await labSubscriberService.add({
      company_name: values.company_name,
      endpoint: values.endpoint,
      is_active: values.is_active,
      suppliers: values.suppliers ?? []
    } as any);
    if (res?.id) {
      navigate('..');
    }
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <LabSubscriberForm
        labSubscriber={initLabSubscriber as ILabSubscriber}
        onSubmit={createLabSubscriber}
      />
    </TenantPage>
  );
};

export default CreateLabSubscriber;
